(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitment-matrix"] && !Shopify.designMode) return;
  try {
    
  /* Highlights the column of the model saved in the garage. Pure decoration on top of a table
     that is already complete and readable without it — and the highlight is never the only
     signal, because every cell still spells out "Fits" or "Does not fit" for assistive tech. */
  (function () {
    var EVENT = 'garage:changed';

    function readGarage(key) {
      try {
        var raw = window.localStorage.getItem(key || 'ot:garage');
        if (!raw) return { slug: '', name: '' };
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.slug) return { slug: '', name: '' };
        return { slug: String(parsed.slug), name: String(parsed.name || parsed.slug) };
      } catch (error) {
        return { slug: '', name: '' };
      }
    }

    if (!customElements.get('fitment-matrix')) {
      customElements.define(
        'fitment-matrix',
        class extends HTMLElement {
          connectedCallback() {
            this.cells = Array.from(this.querySelectorAll('[data-model]'));
            if (!this.cells.length) return;
            this.handler = this.onChange.bind(this);
            document.addEventListener(EVENT, this.handler);
            this.render(readGarage(this.getAttribute('key')));
          }

          disconnectedCallback() {
            if (this.handler) document.removeEventListener(EVENT, this.handler);
          }

          onChange(event) {
            this.render(event.detail || { slug: '', name: '' });
          }

          render(detail) {
            var slug = detail.slug;
            this.cells.forEach(function (cell) {
              if (slug && cell.getAttribute('data-model') === slug) {
                cell.setAttribute('data-active', '');
              } else {
                cell.removeAttribute('data-active');
              }
            });
          }
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-fitment"] && !Shopify.designMode) return;
  try {
    
  /* The hero clip never competes with the LCP image: the <video> ships with preload="none" and
     only starts once the page has finished loading, the tile is on screen, and the visitor has
     not asked for reduced motion. If any of that is false the poster simply stays. */
  (function () {
    if (customElements.get('hero-media')) return;

    customElements.define(
      'hero-media',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video || this.getAttribute('data-autoplay') !== 'true') return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.start = this.start.bind(this);
          if (document.readyState === 'complete') {
            this.start();
          } else {
            window.addEventListener('load', this.start, { once: true });
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        start() {
          var host = this;
          this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) {
                host.video.pause();
                return;
              }
              host.video.preload = 'auto';
              var attempt = host.video.play();
              if (attempt && attempt.then) {
                attempt.then(function () {
                  host.setAttribute('data-playing', '');
                }).catch(function () {
                  host.removeAttribute('data-playing');
                });
              } else {
                host.setAttribute('data-playing', '');
              }
            });
          });
          this.observer.observe(this);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  /* Two small enhancements, both optional: without them every card and every pill still works
     (the pills fall back to being inert, the grid shows everything). Nothing here talks to the
     network and nothing is stored. */
  (function () {
    var EVENT = 'garage:changed';

    function readGarage(key) {
      try {
        var raw = window.localStorage.getItem(key || 'ot:garage');
        if (!raw) return { slug: '', name: '' };
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.slug) return { slug: '', name: '' };
        return { slug: String(parsed.slug), name: String(parsed.name || parsed.slug) };
      } catch (error) {
        return { slug: '', name: '' };
      }
    }

    /* "Fits your {model}" is finished in the browser, so the HTML stays the same for every
       visitor and stays cacheable. */
    if (!customElements.get('garage-text')) {
      customElements.define(
        'garage-text',
        class extends HTMLElement {
          connectedCallback() {
            this.target = this.querySelector('[data-template]');
            if (!this.target) return;
            this.template = this.target.getAttribute('data-template') || '';
            this.fallback = this.target.textContent.trim();
            this.handler = this.onChange.bind(this);
            document.addEventListener(EVENT, this.handler);
            this.render(readGarage(this.getAttribute('key')));
          }

          disconnectedCallback() {
            if (this.handler) document.removeEventListener(EVENT, this.handler);
          }

          onChange(event) {
            this.render(event.detail || { slug: '', name: '' });
          }

          render(detail) {
            if (!this.target) return;
            var text = this.fallback;
            if (detail.name && this.template) {
              text = this.template.split('{model}').join(detail.name);
            }
            if (text) this.target.textContent = text;
          }
        }
      );
    }

    /* Filter first, then page through the result: page 2 of "Wheelie bars" is the next
       wheelie bars, not whatever sat on page 2 of the unfiltered grid. The server already
       rendered page 1 (cards past it carry `hidden`), so nothing moves until a click. */
    if (!customElements.get('part-filter')) {
      customElements.define(
        'part-filter',
        class extends HTMLElement {
          connectedCallback() {
            this.pills = Array.from(this.querySelectorAll('[data-filter-value]'));
            this.cells = Array.from(this.querySelectorAll('[data-filter-keys]'));
            this.pager = this.querySelector('[data-pager]');
            this.perPage = parseInt(this.getAttribute('data-per-page'), 10) || 0;
            this.filter = '';
            this.page = 1;
            if (!this.cells.length) return;
            this.onClick = this.onClick.bind(this);
            this.addEventListener('click', this.onClick);
          }

          disconnectedCallback() {
            if (this.onClick) this.removeEventListener('click', this.onClick);
          }

          onClick(event) {
            var pill = event.target.closest('[data-filter-value]');
            if (pill && this.contains(pill)) {
              this.filter = pill.getAttribute('data-filter-value') || '';
              this.page = 1;
              this.pills.forEach(function (node) {
                node.setAttribute('aria-pressed', node === pill ? 'true' : 'false');
              });
              this.apply(false);
              return;
            }
            var pageButton = event.target.closest('[data-page]');
            if (pageButton && this.contains(pageButton)) {
              this.page = parseInt(pageButton.getAttribute('data-page'), 10) || 1;
              this.apply(true);
            }
          }

          apply(scroll) {
            var probe = ' ' + this.filter + ' ';
            var filter = this.filter;
            var matched = this.cells.filter(function (cell) {
              return !filter || (cell.getAttribute('data-filter-keys') || '').indexOf(probe) > -1;
            });
            var size = this.perPage || matched.length || 1;
            var pages = Math.max(1, Math.ceil(matched.length / size));
            if (this.page > pages) this.page = pages;
            var start = (this.page - 1) * size;
            var visible = matched.slice(start, start + size);
            this.cells.forEach(function (cell) {
              cell.hidden = visible.indexOf(cell) === -1;
            });
            this.renderPager(pages);
            if (scroll) {
              var top = this.getBoundingClientRect().top;
              if (top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }

          renderPager(pages) {
            if (!this.pager) return;
            this.pager.hidden = pages < 2;
            var template = this.pager.getAttribute('data-label') || '%n';
            var current = this.page;
            var buttons = [];
            for (var n = 1; n <= pages; n += 1) {
              var button = document.createElement('button');
              button.type = 'button';
              button.className = 'pgrid__page';
              button.setAttribute('data-page', String(n));
              button.setAttribute('aria-label', template.split('%n').join(String(n)));
              if (n === current) button.setAttribute('aria-current', 'page');
              button.textContent = String(n);
              buttons.push(button);
            }
            this.pager.replaceChildren.apply(this.pager, buttons);
          }
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /* One observer per section node; the fetched HTML replaces only this container, so the rest
     of the page is untouched and no script inside the response has to run. */
  document.querySelectorAll('[data-recommendations]').forEach((host) => {
    if (host.dataset.loaded || !host.dataset.url) return;
    if (host.querySelector('.prec__grid')) return;
    const load = () => {
      host.dataset.loaded = '1';
      fetch(host.dataset.url)
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          if (!text) return;
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const fresh = parsed.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) host.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    };
    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        load();
      },
      { rootMargin: '0px 0px 300px 0px' }
    );
    observer.observe(host);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stage-ladder"] && !Shopify.designMode) return;
  try {
    
  /* `garage-text` is defined here as well as in the product grid: whichever section is on the
     page registers it, and the guard keeps the second registration from throwing. */
  (function () {
    var EVENT = 'garage:changed';

    function readGarage(key) {
      try {
        var raw = window.localStorage.getItem(key || 'ot:garage');
        if (!raw) return { slug: '', name: '' };
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.slug) return { slug: '', name: '' };
        return { slug: String(parsed.slug), name: String(parsed.name || parsed.slug) };
      } catch (error) {
        return { slug: '', name: '' };
      }
    }

    function fits(list, slug) {
      if (!list || !slug) return false;
      return (' ' + list + ' ').indexOf(' ' + slug + ' ') !== -1;
    }

    if (!customElements.get('garage-text')) {
      customElements.define(
        'garage-text',
        class extends HTMLElement {
          connectedCallback() {
            this.target = this.querySelector('[data-template]');
            if (!this.target) return;
            this.template = this.target.getAttribute('data-template') || '';
            this.fallback = this.target.textContent.trim();
            this.handler = this.onChange.bind(this);
            document.addEventListener(EVENT, this.handler);
            this.render(readGarage(this.getAttribute('key')));
          }

          disconnectedCallback() {
            if (this.handler) document.removeEventListener(EVENT, this.handler);
          }

          onChange(event) {
            this.render(event.detail || { slug: '', name: '' });
          }

          render(detail) {
            if (!this.target) return;
            var text = this.fallback;
            if (detail.name && this.template) {
              text = this.template.split('{model}').join(detail.name);
            }
            if (text) this.target.textContent = text;
          }
        }
      );
    }

    /* One stage sells one bundle per scooter model. Until the garage answers, the first offer
       is the visible one — so a visitor without JavaScript still sees a real price. */
    if (!customElements.get('stage-offers')) {
      customElements.define(
        'stage-offers',
        class extends HTMLElement {
          connectedCallback() {
            this.offers = Array.from(this.children);
            if (this.offers.length < 2) return;
            this.handler = this.onChange.bind(this);
            document.addEventListener(EVENT, this.handler);
            var holder = this.closest('[data-garage-key]');
            this.render(readGarage(holder ? holder.getAttribute('data-garage-key') : ''));
          }

          disconnectedCallback() {
            if (this.handler) document.removeEventListener(EVENT, this.handler);
          }

          onChange(event) {
            this.render(event.detail || { slug: '', name: '' });
          }

          render(detail) {
            var slug = detail.slug;
            var matched = false;
            this.offers.forEach(function (offer) {
              var ok = fits(offer.getAttribute('data-fits'), slug);
              if (ok) matched = true;
              offer.hidden = Boolean(slug) && !ok;
            });
            if (slug && !matched) {
              this.offers.forEach(function (offer, index) {
                offer.hidden = index !== 0;
              });
            }
            this.setAttribute('data-resolved', '');
          }
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-strip"] && !Shopify.designMode) return;
  try {
    
  /* The rail is a native overflow scroller, so the posters keep working with loading="lazy".
     The clips are the expensive part: they stay at preload="none" until the page has loaded or
     the visitor touches the rail, and only the tile on screen ever plays. */
  (function () {
    if (customElements.get('ugc-track')) return;

    customElements.define(
      'ugc-track',
      class extends HTMLElement {
        connectedCallback() {
          this.videos = Array.from(this.querySelectorAll('video'));
          if (!this.videos.length) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.hydrate = this.hydrate.bind(this);
          this.addEventListener('pointerdown', this.hydrate, { once: true });
          this.addEventListener('scroll', this.hydrate, { once: true, passive: true });
          if (document.readyState === 'complete') {
            this.hydrate();
          } else {
            window.addEventListener('load', this.hydrate, { once: true });
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        hydrate() {
          if (this.observer) return;
          this.observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                var video = entry.target;
                if (!entry.isIntersecting) {
                  video.pause();
                  return;
                }
                video.preload = 'auto';
                var attempt = video.play();
                if (attempt && attempt.catch) attempt.catch(function () {});
              });
            },
            { threshold: 0.6 }
          );
          this.videos.forEach(function (video) {
            this.observer.observe(video);
          }, this);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
